import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, watch } from 'vue';
import Notes from './components/Notes.vue';
import General from './components/General.vue';
import Services from './components/Services.vue';
import MedicaidTable from './components/MedicaidTable.vue';
import { PersonStores } from '@/store';
import { can, useTenant } from '@/composables';
import { PERMISSIONS, TENANT_SETTINGS } from '@/enum';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'TreatmentPlans',
  setup(__props) {

const treatmentPlansStore = PersonStores.useUserTreatmentPlansStore();
const profileStore = PersonStores.useUserProfileStore();
const hasError = computed(() => !!treatmentPlansStore.error);
const { id } = storeToRefs(profileStore);
const $tenant = useTenant();
const medicaidEnabled = computed(() => $tenant.tenantSettingEnabled(TENANT_SETTINGS.MEDICAID_BILLING));

const canViewTreatmentPlanAndPlanExists = computed(() => {
  return can([PERMISSIONS.PERSON_TREATMENT_PLANS_INDEX_STUDENTS]) && !!treatmentPlansStore.planId;
});

const init = async () => {
  treatmentPlansStore.showExpired = false;
  if (profileStore.id != treatmentPlansStore.userTreatmentPlans?.person_id) {
    treatmentPlansStore.userTreatmentPlans = undefined;
    treatmentPlansStore.treatmentPlanCategories = undefined;
  }

  if (profileStore.id && can([PERMISSIONS.PERSON_TREATMENT_PLANS_INDEX_STUDENTS])) {
    await treatmentPlansStore.getUserTreatmentPlans(profileStore.id);
    await treatmentPlansStore.fetchAllTreatmentPlanFormData();
  }

  if (hasError.value) {
    treatmentPlansStore.doToast(treatmentPlansStore.error as string, 'Error', true);
  }
};

watch(id, init);

onMounted(() => init());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(General),
    (canViewTreatmentPlanAndPlanExists.value && medicaidEnabled.value)
      ? (_openBlock(), _createBlock(MedicaidTable, {
          key: _unref(treatmentPlansStore).planId,
          onUpdate: init
        }))
      : _createCommentVNode("", true),
    (canViewTreatmentPlanAndPlanExists.value)
      ? (_openBlock(), _createBlock(Services, {
          key: _unref(treatmentPlansStore).planId
        }))
      : _createCommentVNode("", true),
    (canViewTreatmentPlanAndPlanExists.value)
      ? (_openBlock(), _createBlock(Notes, {
          key: _unref(treatmentPlansStore).planId
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})